<button class="bg-slate-00 button-icon ml-auto text-color-black d-lg-none" mat-dialog-close>
  <lib-icon>close</lib-icon>
</button>
<p class="text-size-20 fw-600 mb-3">Need help? Contact {{agentSignature.type === AgentSignatureType.AGENCY ? 'us' : 'me' }}.</p>
<mat-dialog-content>
  <lib-agent-signature [agentSignature]="agentSignature"></lib-agent-signature>
</mat-dialog-content>
